export default __webpack_public_path__ + "static/media/device.a6c2d475.svg";